export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH'
export const SET_USE_CASES = 'SET_USE_CASES'
export const SET_CURRENT_USE_CASE = 'SET_CURRENT_USE_CASE'
export const SET_SHOULD_SHOW_USE_CASES = 'SET_SHOULD_SHOW_USE_CASES'
export const SET_WINDOW_HEIGHT = 'SET_WINDOW_HEIGHT'
export const SET_IS_DESKTOP = 'SET_IS_DESKTOP'
